import React, { PureComponent } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Form, ImageInput, required } from 'react-admin';
import ImgField from '../../../components/ImgField/ImgField';

class EditAvatarModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = (values) => {
    this.handleClose();
    return this.props.onSave(values);
  };

  render() {
    const { children } = this.props;
    return (
      <>
        <div onClick={this.handleClickOpen} aria-hidden="true">
          {children}
        </div>
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
        >
          <DialogTitle id="customized-dialog-title">Edit Avatar</DialogTitle>
          {/* Own record so the input starts empty rather than adopting the profile record. */}
          <Form onSubmit={this.handleSubmit} record={{}}>
            <DialogContent>
              <ImageInput source="picture" label="Picture" validate={required()}>
                <ImgField source="picture" title="Picture" addLabel width="270" height="270" />
              </ImageInput>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>close</Button>
              <Button variant="contained" type="submit" color="primary">
                Save changes
              </Button>
            </DialogActions>
          </Form>
        </Dialog>
      </>
    );
  }
}

export default EditAvatarModal;
